module.exports = __webpack_public_path__ + "img/help.c317a834.svg";